// extracted by mini-css-extract-plugin
export default {"root":"EmailRow_root__CnGCP","row":"EmailRow_row__wKaJO","subject":"EmailRow_subject__Dn8ix"};